import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import MultiSelect from '@components/form/MultiSelect';
import TextInput from '@components/form/TextInput';
import Modal from '@components/modal/Modal';
import { removeInvalidSelectValues } from 'lib/src/utils/generic';
import useEditChallengeGroup from './hooks/useEditChallengeGroup';
import useSite from 'lib/src/hooks/useSite';
import { DropdownOption } from 'lib/src/types/shared/DropdownOption';
import { site as siteEnum } from 'lib/src/shared/enums/site';
import Select from '@components/form/Select';

const EditChallengeGroupModal = ({ id }: EditChallengeGroupModalProps) => {
    const {
        handleSubmit,
        handleChange,
        closeModal,
        isPosting,
        formState: { name, adminIDs, viewerIDs, site },
        adminOptions,
        viewerOptions,
    } = useEditChallengeGroup(id);

    const userSite = useSite();
    const siteOptions: DropdownOption<siteEnum>[] = [
        { label: 'IX', value: siteEnum.IX },
        { label: 'GA', value: siteEnum.GA },
    ];

    return (
        <Modal title="Edit Challenge Group" size="small" closeModal={closeModal}>
            <Form onCancel={closeModal} onSubmit={handleSubmit} isPosting={isPosting}>
                <FormRow>
                    <TextInput
                        name="name"
                        value={name}
                        onChange={handleChange}
                        label="Name"
                        placeholder="Name of this Challenge Group"
                        required
                    />
                </FormRow>

                <FormRow>
                    <MultiSelect
                        name="adminIDs"
                        search
                        value={removeInvalidSelectValues(adminIDs, adminOptions)}
                        onChange={handleChange}
                        label="Admins"
                        options={adminOptions}
                    />
                    <MultiSelect
                        name="viewerIDs"
                        search
                        value={removeInvalidSelectValues(viewerIDs, viewerOptions)}
                        onChange={handleChange}
                        label="Viewers"
                        options={viewerOptions}
                    />
                    {userSite === siteEnum.ALL && (
                        <Select
                            name="site"
                            value={site}
                            onChange={handleChange}
                            label="Site"
                            options={siteOptions}
                            canBeEmpty={false}
                            required
                        />
                    )}
                </FormRow>
            </Form>
        </Modal>
    );
};

interface EditChallengeGroupModalProps {
    id: number;
}

export default EditChallengeGroupModal;
